import React from "react";

import styled from "styled-components";
import Image from "../../atoms/Images";
import BackgroundImage from "../../../assets/icons/Logo.svg";
import LogoTitleWrapper from "../LogoTitleWrapper";
import LogoImageWrapper from "../../atoms/LogoImageWrapper";
import { MIN_MORNITOR_WIDTH } from "../../constants";

const Logo: React.FC = () => {
  return (
    <LogoWrapper>
      <LogoTitleWrapper />
      <LogoImageWrapper>
        <Image src={BackgroundImage} alt="배경" />
      </LogoImageWrapper>
    </LogoWrapper>
  );
};
export default Logo;
const LogoWrapper = styled.div`
  width: 37.5vw;

  min-width: 540px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
    180deg,
    #6a1cfc 1.83%,
    #6a20fc 18.41%,
    #692bfc 33.05%,
    #673dfb 47.69%,
    #6458fb 62.32%,
    #617afa 75.98%,
    #5da2f9 89.64%,
    #5ac5f8 99.4%
  );
  align-items: center;
  align-content: center;
  overflow: hidden;

  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    display: none;
  }
`;
